import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { BaseProvider } from '../providers/base-provider';

import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessProductExpeditorHandlerProvider extends BaseProvider {
	ticketList: any = [];
	term: any = "";

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
		super();
		this.baseUrl = "businessProductExpediter";

	}

	refreshOrders(){
		this.getOpenOrders({term: this.term});
	}

  	getOpenOrders(params){	
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 
		  			   this.baseUrl + 
	    		   	   ((params.term!="") ? "?term=" + params.term : "");

	   		this.term = params.term;

			this.storage.get('loginData').then((loginData) => {
			    this.http.get(
			        this.url,
			        this.httpHelper.configOptionsWithToken(loginData.access_token)
			    )
			    .map(res => res.json())
			    .subscribe(
					data => {
						this.ticketList = data.Data;

						resolve(data);
					},
					err => {reject(err)}
			   	);  
			});
		});    	
  	}

  	getInvoice(id){	
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 
		  			   this.baseUrl + '/' + id

			this.storage.get('loginData').then((loginData) => {
			    this.http.get(
			        this.url,
			        this.httpHelper.configOptionsWithToken(loginData.access_token)
			    )
			    .map(res => res.json())
			    .subscribe(
					data => {					
						resolve(data);
					},
					err => {reject(err)}
			   	);  
			});
		});    	
  	}  	

  	redeem(params){
	    this.url = this.globals.dataUrl + 
    		   	   this.baseUrl + 
	    		   '/redeem/' + params.invoiceId;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})           
	}

}



// WEBPACK FOOTER //
// ./src/providers/business-product-expeditor-handler.ts